import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";
const ViswapriyaFunctionHall = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  // const images = [
  //   "/images/viswa sai 1.jpg",
  //   "/images/viswa sai 2.jpg",
  //   "/images/viswa sai 3.jpg",
  // ];

  const pricingData = [
    {
      id: 1,
      purpose:
        "Birthday functions, Corporate meetings, Get-togethers, Marriage functions, Engagements, Receptions (General Public)",
      rent: 35000,
      deposit: 20000,
      gst: 7200,
      cleaning: 5000,
      total: 67200,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img
                  src={item.url}
                  alt={`Viswapriya Function Hall Image ${idx + 1}`}
                />
                <div className="overlay">
                  <h1>Viswapriya Function Hall</h1>
                  <p>Ideal Venue for Social and Corporate Functions</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Venue Details */}
        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Viswapriya Function Hall</strong> is a spacious and
            well-maintained venue located in Visakhapatnam, ideal for hosting
            birthday functions, corporate meetings, get-togethers, marriage
            functions, engagements, and receptions.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Spacious and Air-Conditioned Hall</li>
            <li>✅ Ideal for Social and Corporate Events</li>
            <li>✅ Modern Audio and Visual Systems</li>
            <li>✅ Ample Parking Space</li>
            <li>✅ Clean and Well-Maintained Premises</li>
          </ul>

          {/* Pricing Section */}
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Electrical charges as consumed will be paid
            by the applicant.
          </p>

          {/* Contact Information */}
          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@viswapriyafunctionhall.com
            </p>
          </div>

          {/* Book Now Button */}
          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ViswapriyaFunctionHall;
